import React from 'react'
import { DatePicker } from 'antd'

import dayjs from 'dayjs'

import { useSelector, useDispatch } from 'react-redux'
import { updateDate } from '../../redux'
import { leagueStart } from '../../config/constants'

const WeekPagination = () => {
  const { date: currentDate } = useSelector((state) => state?.user?.setting)
  const SETTING = useSelector((state) => state?.user)

  const dispatch = useDispatch()

  // const disabledDate = (current) => {
  //   return current && current > dayjs(SETTING.currentDate)
  // }

  const disabledDate = (current) => {
    const currentDay = dayjs(current)
    const minDate = dayjs(leagueStart)
    const maxDate = dayjs(SETTING.currentDate)
    return currentDay.isBefore(minDate) || currentDay.isAfter(maxDate)
  }

  return (
    <div className='date_picker_box'>
      <DatePicker
        inputReadOnly={true}
        placeholder='Select Date'
        value={dayjs(currentDate)}
        onChange={(_, dateString) => {
          dispatch(updateDate(dateString))
        }}
        disabledDate={disabledDate}
      />
    </div>
  )
}

export default WeekPagination
